import { superAdminApi } from "./authService";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  ClientRecordTemplateSchema,
} from "./clientRecordTemplateService";

const RESOURCE = "/super-admin/client-record-template-presets";

export type HealthRecordTemplatePresetType = "anamnesis" | "evolution";

export interface HealthRecordTemplatePreset {
  id: number;
  slug: string;
  title: string;
  specialty: string;
  record_type?: HealthRecordTemplatePresetType;
  schema_json: ClientRecordTemplateSchema;
  is_active: boolean;
  sort_order: number;
  tenant_templates_count?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateHealthRecordTemplatePresetPayload {
  slug: string;
  title: string;
  specialty: string;
  record_type?: HealthRecordTemplatePresetType;
  schema_json: ClientRecordTemplateSchema;
  is_active?: boolean;
  sort_order?: number;
}

export type UpdateHealthRecordTemplatePresetPayload =
  Partial<CreateHealthRecordTemplatePresetPayload>;

export interface HealthRecordTemplatePresetListParams extends PaginationParams {
  search?: string;
  is_active?: boolean;
  record_type?: HealthRecordTemplatePresetType;
}

export const getHealthRecordPresets = async (
  params?: HealthRecordTemplatePresetListParams
): Promise<PaginatedApiResponse<HealthRecordTemplatePreset>> => {
  const response = await superAdminApi.get<
    PaginatedApiResponse<HealthRecordTemplatePreset>
  >(RESOURCE, { params });

  return response.data;
};

export const getHealthRecordPreset = async (
  id: number
): Promise<ApiResponse<HealthRecordTemplatePreset>> => {
  const response = await superAdminApi.get<ApiResponse<HealthRecordTemplatePreset>>(
    `${RESOURCE}/${id}`
  );

  return response.data;
};

export const createHealthRecordPreset = async (
  payload: CreateHealthRecordTemplatePresetPayload
): Promise<ApiResponse<HealthRecordTemplatePreset>> => {
  const response = await superAdminApi.post<
    ApiResponse<HealthRecordTemplatePreset>
  >(RESOURCE, payload);

  return response.data;
};

export const updateHealthRecordPreset = async (
  id: number,
  payload: UpdateHealthRecordTemplatePresetPayload
): Promise<ApiResponse<HealthRecordTemplatePreset>> => {
  const response = await superAdminApi.patch<
    ApiResponse<HealthRecordTemplatePreset>
  >(`${RESOURCE}/${id}`, payload);

  return response.data;
};

export const deleteHealthRecordPreset = async (
  id: number
): Promise<ApiResponse<Record<string, never>>> => {
  const response = await superAdminApi.delete<
    ApiResponse<Record<string, never>>
  >(`${RESOURCE}/${id}`);

  return response.data;
};
